import { useRef } from "react";
import { AgGridReact } from "ag-grid-react";
import Actionbar from "src/components/common/actionbar/Authactionbar";
import { Message } from "src/components/common/form/Message";
import useUiuxStore from "src/store/useUiuxStore";
import { Content_PRD2040_R01 } from "./Content_PRD2040_R01";
import { SearchSection_PRD2040_R01 } from "./SearchSection_PRD2040_R01";
import { Table_PRD2040_R01 } from "./Table_PRD2040_R01";

export const Container_PRD2040_R01 = () => {
    const { setMessage } = useUiuxStore();

    const gridRef = useRef<AgGridReact<any>>(null);

    const {
        fetchData,
        initContainerData,
        handleExcelClick,
    } = Content_PRD2040_R01();

    return (
        <div className="content-container">
            <Actionbar
                onFetchClick={fetchData}
                onCreateClick={() => {}}
                onDeleteClick={() => {}}
                onSaveClick={() => {}}
                onExcelClick={handleExcelClick}
                onInitClick={initContainerData}
            />

            <SearchSection_PRD2040_R01
                onEnterKeyDown={(e) => {
                    if (e.key === 'Enter') fetchData();
                }}
            />

            {/* 테이블 영역 */}
            <div className="flex-1 flex">
                <div className="w-full h-full flex flex-col p-[12px] gap-[12px]">
                    <Table_PRD2040_R01 gridRef={gridRef} />
                </div>
            </div>

            <Message />
        </div>
    );
};

export default Container_PRD2040_R01;
